import React from "react";
import { Form } from "react-bootstrap";
import { SET_SIDEBAR_FILTER, useArsContext } from "../contexts";
import { DatasetSelect } from "./DatasetSelect";

/**
 * ArsTableSidebarFilter provides a text input that filters sidebar items
 * by matching against the currently visible items' names or descriptions.
 *
 * @returns Filter input element, or null when there is no table context
 */
export const ArsSidebarFilter = (): React.ReactNode => {
  const { state, dispatch } = useArsContext();

  return (
    <>
      {state.currentSidebar.view === "variable" && <DatasetSelect />}
      <Form.Control
        id="ars-sidebar-filter"
        size="sm"
        type="text"
        aria-label="Filter sidebar items"
        placeholder="Filter items…"
        value={state.currentSidebar.filter}
        onChange={(event) => {
          dispatch({
            operation: SET_SIDEBAR_FILTER,
            filter: event.currentTarget.value,
          });
        }}
      />
    </>
  );
};

ArsSidebarFilter.displayName = "ArsSidebarFilter";
